window.addEventListener('DOMContentLoaded', () => {

    const nav = document.getElementById('mobile-nav');
    const navInner = nav ? nav.querySelector('.mobile-nav-list-inner') : null;
    const navWrapper = nav ? nav.querySelector('.mobile-nav-list-wrapper') : null;
    const progress = document.getElementById('progress');
    const cursor = document.getElementById('cursor');
    const cursorRing = document.getElementById('cursorRing');

    const shouldUseCustomCursor = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    if (cursor && cursorRing && shouldUseCustomCursor) {
        let mouseX = window.innerWidth / 2;
        let mouseY = window.innerHeight / 2;
        let ringX = mouseX;
        let ringY = mouseY;

        document.addEventListener('mousemove', (event) => {
            mouseX = event.clientX;
            mouseY = event.clientY;
            cursor.style.left = `${mouseX}px`;
            cursor.style.top = `${mouseY}px`;
        });

        const animateRing = () => {
            ringX += (mouseX - ringX) * 0.12;
            ringY += (mouseY - ringY) * 0.12;
            cursorRing.style.left = `${ringX}px`;
            cursorRing.style.top = `${ringY}px`;
            requestAnimationFrame(animateRing);
        };

        animateRing();

        // The dot/ring only move on "mousemove", which never fires while the
        // pointer is over an <iframe> (the Predajne page's Google Map, for
        // example) — it's a separate document. Without this, the cursor
        // freezes at its last position when you enter an iframe (and the
        // native cursor reappears there, since that page isn't ours to
        // style), which can look like it vanished or is stuck in the wrong
        // spot. Hide it while over any iframe and let mousemove bring it
        // back once the pointer returns to our page.
        document.querySelectorAll('iframe').forEach((frame) => {
            frame.addEventListener('mouseenter', () => {
                cursor.style.opacity = '0';
                cursorRing.style.opacity = '0';
            });
            frame.addEventListener('mouseleave', () => {
                cursor.style.opacity = '';
                cursorRing.style.opacity = '';
            });
        });

        // If the pointer leaves the browser viewport entirely (another
        // window/tab, a second monitor, the URL bar, ...) and comes back,
        // there's a gap with no "mousemove" in between — the dot/ring would
        // otherwise still show at their last (now stale) position. Hide
        // them on the way out so re-entry is a clean reappearance instead
        // of a jump.
        document.documentElement.addEventListener('mouseleave', () => {
            cursor.style.opacity = '0';
            cursorRing.style.opacity = '0';
        });
        document.documentElement.addEventListener('mouseenter', () => {
            cursor.style.opacity = '';
            cursorRing.style.opacity = '';
        });

        document.querySelectorAll('a, button').forEach((element) => {
            element.addEventListener('mouseenter', () => {
                cursor.style.transform = 'translate(-50%, -50%) scale(2)';
                cursorRing.style.transform = 'translate(-50%, -50%) scale(1.5)';
            });

            element.addEventListener('mouseleave', () => {
                cursor.style.transform = 'translate(-50%, -50%) scale(1)';
                cursorRing.style.transform = 'translate(-50%, -50%) scale(1)';
            });
        });
    }

    let mobileNavReturnFocus = null;
    const resizeMobileNav = () => {
        if (!nav || !navInner || !navWrapper) return;
        const isOpen = nav.classList.contains('mobile-nav-open');
        const innerHeight = navInner.scrollHeight;
        nav.style.height = isOpen ? `${innerHeight + 58}px` : '58px';
        navWrapper.style.height = isOpen ? `${innerHeight}px` : '0';
        navWrapper.inert = !isOpen;
        navWrapper.setAttribute('aria-hidden', String(!isOpen));
        document.querySelectorAll('[aria-controls="BozidarMobileMenu"]').forEach((trigger) => {
            trigger.setAttribute('aria-expanded', String(isOpen));
        });
    };
    const openMobileNav = (trigger) => {
        if (!nav || !navInner || !navWrapper) return;
        const willOpen = !nav.classList.contains('mobile-nav-open');
        if (willOpen) mobileNavReturnFocus = trigger || document.activeElement;
        nav.classList.toggle('mobile-nav-open', willOpen);
        resizeMobileNav();
        if (willOpen) {
            const firstControl = navInner.querySelector('input, a, button');
            if (firstControl) firstControl.focus({ preventScroll: true });
        } else if (mobileNavReturnFocus) {
            mobileNavReturnFocus.focus({ preventScroll: true });
        }
    };
    window.openMobileNav = openMobileNav;
    resizeMobileNav();
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && nav && nav.classList.contains('mobile-nav-open')) openMobileNav();
    });
    window.addEventListener('resize', () => {
        if (nav && window.innerWidth > 992 && nav.classList.contains('mobile-nav-open')) {
            nav.classList.remove('mobile-nav-open');
        }
        resizeMobileNav();
    });

    const updateScrollIndicators = () => {
        if (nav) {
            nav.classList.toggle('scrolled', window.scrollY > 60);
        }

        if (progress) {
            const p = window.scrollY / (document.body.scrollHeight - window.innerHeight) * 100;
            progress.style.width = p + '%';
        }
    };

    window.addEventListener('scroll', updateScrollIndicators);
    updateScrollIndicators();

    // Hero bg subtle zoom on load
    setTimeout(() => {
        const heroBg = document.getElementById('heroBg');
        if (heroBg) { 
            heroBg.classList.add('loaded');
        }
    }, 100);

    // Scroll reveal
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(e => {
            if (e.isIntersecting) {
                e.target.classList.add('in');
                observer.unobserve(e.target);
            }
        });
    }, { threshold: 0.12 });

    document.querySelectorAll('.reveal, .reveal-left, .reveal-right, .reveal-up').forEach(el => observer.observe(el));

    (function initLandscapeLineAnimation() {
        const svg = document.getElementById('landscapeLineSvg')
            || document.querySelector('.landscape-line-svg')
            || document.querySelector('[data-line-animation] svg');

        if (!svg) {
            return;
        }

        const paths = Array.from(svg.querySelectorAll('path'));

        if (!paths.length) {
            return;
        }

        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        paths.forEach((path) => {
            try {
                const len = path.getTotalLength();
                path.style.strokeDasharray = `${len}`;
                path.style.strokeDashoffset = prefersReducedMotion ? '0' : `${len}`;
                path.dataset.pathLength = `${len}`;
            } catch (_) {
                path.style.strokeDasharray = '0';
                path.style.strokeDashoffset = '0';
            }
        });

        if (prefersReducedMotion) {
            return;
        }

        const animatePaths = () => {
            paths.forEach((path, index) => {
                const len = Number(path.dataset.pathLength || 0);
                const baseDuration = 0.35 + (len / 1800) * 1.4;
                const duration = Math.max(0.25, Math.min(baseDuration, 2.2));
                const delay = index * 0.012;

                path.style.animation = 'none';
                path.getBoundingClientRect();
                path.style.animation = `landscapeLineDraw ${duration}s ${delay}s cubic-bezier(0.4, 0, 0.2, 1) forwards`;
            });
        };

        const lineObserver = new IntersectionObserver((entries, obs) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    animatePaths();
                    obs.disconnect();
                }
            });
        }, { threshold: 0.2 });

        lineObserver.observe(svg);
    })();

    (function initProductDialog() {
        const dialog = document.getElementById('productDialog');
        const title = document.getElementById('productDialogTitle');
        const description = document.getElementById('productDialogDescription');
        const whatToExpect = document.getElementById('productDialogWhatToExpect');
        const whatToExpectWrap = document.getElementById('productDialogWhatToExpectWrap');
        const tasteAndAroma = document.getElementById('productDialogTasteAndAroma');
        const tasteAndAromaWrap = document.getElementById('productDialogTasteAndAromaWrap');
        const preparation = document.getElementById('productDialogPreparation');
        const preparationWrap = document.getElementById('productDialogPreparationWrap');
        const suitableFor = document.getElementById('productDialogSuitableFor');
        const suitableForWrap = document.getElementById('productDialogSuitableForWrap');
        const cards = document.querySelectorAll('[data-product-card]');

        if (!dialog || !title || !description || !cards.length) {
            return;
        }

        const setDetail = (element, wrapper, value) => {
            if (!element || !wrapper) {
                return;
            }

            const normalizedValue = (value || '').trim();
            element.textContent = normalizedValue;
            wrapper.hidden = normalizedValue.length === 0;
        };

        const openDialog = (card) => {
            title.textContent = card.dataset.productName || '';
            description.textContent = card.dataset.productDescription || '';
            setDetail(whatToExpect, whatToExpectWrap, card.dataset.productWhatToExpect || '');
            setDetail(tasteAndAroma, tasteAndAromaWrap, card.dataset.productTasteAndAroma || '');
            setDetail(preparation, preparationWrap, card.dataset.productPreparation || '');
            setDetail(suitableFor, suitableForWrap, card.dataset.productSuitableFor || '');
            document.body.classList.add('dialog-open');

            if (typeof dialog.showModal === 'function') {
                dialog.showModal();
            } else {
                dialog.setAttribute('open', 'open');
            }
        };

        cards.forEach((card) => {
            card.addEventListener('click', () => openDialog(card));
            card.addEventListener('keydown', (event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    openDialog(card);
                }
            });
        });

        dialog.addEventListener('click', (event) => {
            if (event.target === dialog) {
                dialog.close();
            }
        });

        dialog.querySelectorAll('[data-product-dialog-close]').forEach((button) => {
            button.addEventListener('click', () => dialog.close());
        });

        dialog.addEventListener('close', () => {
            document.body.classList.remove('dialog-open');
        });
    })();

    // ─── FLORAL CANVAS BACKGROUND (Prečo Boží dar) ───────────────────────────
    (function initFloralCanvas() {
        const canvas = document.getElementById('floralCanvas');
        if (!canvas) return;

        const section = canvas.closest('section');
        const ctx = canvas.getContext('2d');

        function resize() {
            const dpr = window.devicePixelRatio || 1;
            canvas.width = section.offsetWidth * dpr;
            canvas.height = section.offsetHeight * dpr;
            ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        }
        resize();
        window.addEventListener('resize', resize);

        const W = () => section.offsetWidth;
        const H = () => section.offsetHeight;

        const palette = [
            { r:201, g:169, b:110, a:0.18 },
            { r:180, g:144, b:58,  a:0.15 },
            { r:107, g:76,  b:42,  a:0.10 },
            { r:45,  g:62,  b:40,  a:0.12 },
            { r:210, g:185, b:145, a:0.20 },
            { r:160, g:130, b:90,  a:0.14 },
            { r:80,  g:55,  b:30,  a:0.09 },
        ];

        class WatercolorPetal {
            constructor(cx, cy, angle, length, width, color, delay) {
                this.cx = cx; this.cy = cy;
                this.angle = angle; this.length = length; this.width = width;
                this.color = color; this.delay = delay;
                this.points = this.generatePoints();
                this.blobs = this.generateBlobs();
            }
            generatePoints() {
                const pts = [];
                for (let i = 0; i <= 18; i++) {
                    const frac = i / 18;
                    const envelope = Math.sin(frac * Math.PI);
                    const jitter = (Math.random() - 0.5) * this.width * 0.3;
                    const wobble = Math.sin(frac * Math.PI * 3) * this.width * 0.08;
                    pts.push({ frac, dist: frac * this.length, spread: envelope * this.width * 0.5 + jitter + wobble });
                }
                return pts;
            }
            generateBlobs() {
                const blobs = [];
                for (let i = 0; i < 6; i++) {
                    blobs.push({
                        frac: 0.15 + Math.random() * 0.7,
                        offset: (Math.random() - 0.5) * this.width * 0.4,
                        r: this.width * (0.15 + Math.random() * 0.2),
                        a: 0.04 + Math.random() * 0.06,
                    });
                }
                return blobs;
            }
            draw(t) {
                if (t < this.delay) return;
                const progress = Math.min(1, (t - this.delay) / 0.6);
                const maxFrac = 1 - Math.pow(1 - progress, 3);
                const pts = this.points.filter(p => p.frac <= maxFrac);
                if (pts.length < 2) return;
                const c = this.color;
                const alpha = c.a * Math.min(1, progress * 2);
                const cos = Math.cos(this.angle), sin = Math.sin(this.angle);
                const pCos = Math.cos(this.angle + Math.PI / 2), pSin = Math.sin(this.angle + Math.PI / 2);
                const top = pts.map(p => ({ x: this.cx + cos*p.dist + pCos*p.spread, y: this.cy + sin*p.dist + pSin*p.spread }));
                const bot = pts.map(p => ({ x: this.cx + cos*p.dist - pCos*p.spread, y: this.cy + sin*p.dist - pSin*p.spread })).reverse();
                ctx.save();
                ctx.beginPath();
                ctx.moveTo(top[0].x, top[0].y);
                for (let i = 1; i < top.length; i++) {
                    const p = top[i-1], q = top[i];
                    ctx.quadraticCurveTo(p.x, p.y, (p.x+q.x)/2, (p.y+q.y)/2);
                }
                ctx.lineTo(top[top.length-1].x, top[top.length-1].y);
                for (let i = 0; i < bot.length; i++) {
                    if (i === 0) { ctx.lineTo(bot[i].x, bot[i].y); }
                    else { const p = bot[i-1], q = bot[i]; ctx.quadraticCurveTo(p.x, p.y, (p.x+q.x)/2, (p.y+q.y)/2); }
                }
                ctx.closePath();
                ctx.fillStyle = `rgba(${c.r},${c.g},${c.b},${alpha})`;
                ctx.fill();
                this.blobs.forEach(b => {
                    if (b.frac > maxFrac) return;
                    const bx = this.cx + cos*b.frac*this.length + pCos*b.offset;
                    const by = this.cy + sin*b.frac*this.length + pSin*b.offset;
                    const grad = ctx.createRadialGradient(bx, by, 0, bx, by, b.r);
                    grad.addColorStop(0, `rgba(${c.r},${c.g},${c.b},${b.a * Math.min(1, progress*1.5)})`);
                    grad.addColorStop(1, `rgba(${c.r},${c.g},${c.b},0)`);
                    ctx.beginPath();
                    ctx.ellipse(bx, by, b.r, b.r*0.7, this.angle, 0, Math.PI*2);
                    ctx.fillStyle = grad;
                    ctx.fill();
                });
                ctx.restore();
            }
        }

        class FloralCluster {
            constructor(x, y) {
                this.x = x; this.y = y;
                this.petals = [];
                this.t = 0;
                this.speed = 0.006 + Math.random() * 0.004;
                this.generate();
            }
            generate() {
                const count = 5 + Math.floor(Math.random() * 4);
                const base = Math.random() * Math.PI * 2;
                for (let i = 0; i < count; i++) {
                    const angle = base + (i / count) * Math.PI * 2 + (Math.random()-0.5)*0.3;
                    const len = 40 + Math.random() * 60;
                    this.petals.push(new WatercolorPetal(this.x, this.y, angle, len, len*(0.35+Math.random()*0.25),
                        palette[Math.floor(Math.random()*palette.length)], (i/count)*0.4+Math.random()*0.1));
                }
                const stemCount = 2 + Math.floor(Math.random()*2);
                for (let i = 0; i < stemCount; i++) {
                    const angle = base + Math.PI + (Math.random()-0.5)*0.8;
                    const len = 30 + Math.random()*40;
                    this.petals.push(new WatercolorPetal(this.x, this.y, angle, len, 8+Math.random()*10,
                        { r:45, g:62, b:40, a:0.08+Math.random()*0.06 }, 0));
                }
            }
            update() { this.t = Math.min(1, this.t + this.speed); }
            draw() { this.petals.forEach(p => p.draw(this.t)); }
        }

        class LineStem {
            constructor(x, y, angle, length) {
                this.x = x; this.y = y; this.angle = angle; this.length = length;
                this.t = 0; this.speed = 0.008 + Math.random()*0.005;
                this.color = Math.random() < 0.5 ? { r:107,g:76,b:42,a:0.12 } : { r:45,g:62,b:40,a:0.10 };
                this.branches = [];
                for (let i = 0; i < Math.floor(Math.random()*3)+1; i++) {
                    this.branches.push({ frac: 0.3+Math.random()*0.5, angle: angle+(Math.random()-0.5)*1.2,
                        length: length*(0.3+Math.random()*0.3), t: 0 });
                }
            }
            update() {
                this.t = Math.min(1, this.t + this.speed);
                const eased = 1 - Math.pow(1-this.t, 3);
                this.branches.forEach(b => { if (eased >= b.frac) b.t = Math.min(1, b.t + this.speed*0.8); });
            }
            draw() {
                const c = this.color;
                const eased = 1 - Math.pow(1-this.t, 3);
                ctx.save();
                ctx.strokeStyle = `rgba(${c.r},${c.g},${c.b},${c.a})`;
                ctx.lineWidth = 1; ctx.lineCap = 'round';
                ctx.beginPath();
                ctx.moveTo(this.x, this.y);
                ctx.lineTo(this.x + Math.cos(this.angle)*this.length*eased, this.y + Math.sin(this.angle)*this.length*eased);
                ctx.stroke();
                this.branches.forEach(b => {
                    if (b.t <= 0) return;
                    const bEased = 1 - Math.pow(1-b.t, 3);
                    const bx = this.x + Math.cos(this.angle)*this.length*Math.min(b.frac, eased);
                    const by = this.y + Math.sin(this.angle)*this.length*Math.min(b.frac, eased);
                    ctx.lineWidth = 0.6;
                    ctx.beginPath(); ctx.moveTo(bx, by);
                    ctx.lineTo(bx + Math.cos(b.angle)*b.length*bEased, by + Math.sin(b.angle)*b.length*bEased);
                    ctx.stroke();
                });
                ctx.restore();
            }
        }

        let clusters = [], stems = [], started = false;

        function spawnCluster() {
            const m = 60;
            clusters.push(new FloralCluster(m + Math.random()*(W()-m*2), m + Math.random()*(H()-m*2)));
        }
        function spawnStem() {
            stems.push(new LineStem(20+Math.random()*(W()-40), 20+Math.random()*(H()-40),
                -Math.PI/2+(Math.random()-0.5)*0.8, 40+Math.random()*80));
        }

        function frame() {
            ctx.clearRect(0, 0, W(), H());
            stems.forEach(s => { s.update(); s.draw(); });
            clusters.forEach(cl => { cl.update(); cl.draw(); });
            requestAnimationFrame(frame);
        }

        function start() {
            if (started) return;
            started = true;
            resize();
            for (let i = 0; i < 8; i++) spawnCluster();
            for (let i = 0; i < 10; i++) spawnStem();
            frame();
            setTimeout(() => spawnCluster(), 800);
            setTimeout(() => { spawnCluster(); spawnStem(); }, 1600);
        }

        const sectionObs = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting) { start(); sectionObs.disconnect(); }
        }, { threshold: 0.1 });
        sectionObs.observe(section);
    })();

    (function initSectionSliders() {
        const initSectionSlider = (sectionSelector, containerSelector, itemSelector) => {
            const section = document.querySelector(sectionSelector);

            if (!section) {
                return;
            }

            const cardsGrid = section.querySelector(containerSelector);
            const leftButton = section.querySelector('.preco-section-nav.left');
            const rightButton = section.querySelector('.preco-section-nav.right');

            if (!cardsGrid || !leftButton || !rightButton) {
                return;
            }

            const getScrollStep = () => {
                const firstCard = cardsGrid.querySelector(itemSelector);

                if (!firstCard) {
                    return cardsGrid.clientWidth * 0.9;
                }

                const styles = window.getComputedStyle(firstCard);
                const marginLeft = parseFloat(styles.marginLeft) || 0;
                const marginRight = parseFloat(styles.marginRight) || 0;

                return firstCard.getBoundingClientRect().width + marginLeft + marginRight;
            };

            const updateButtonVisibility = () => {
                const maxScrollLeft = cardsGrid.scrollWidth - cardsGrid.clientWidth;

                if (maxScrollLeft <= 1) {
                    leftButton.style.display = 'none';
                    rightButton.style.display = 'none';
                    return;
                }

                const isAtStart = cardsGrid.scrollLeft <= 1;
                const isAtEnd = cardsGrid.scrollLeft >= maxScrollLeft - 1;

                leftButton.style.display = isAtStart ? 'none' : '';
                rightButton.style.display = isAtEnd ? 'none' : '';
            };

            rightButton.addEventListener('click', () => {
                cardsGrid.scrollBy({
                    left: getScrollStep(),
                    behavior: 'smooth'
                });
            });

            leftButton.addEventListener('click', () => {
                cardsGrid.scrollBy({
                    left: -getScrollStep(),
                    behavior: 'smooth'
                });
            });

            cardsGrid.addEventListener('scroll', updateButtonVisibility, { passive: true });
            window.addEventListener('resize', updateButtonVisibility);
            updateButtonVisibility();
        };

        initSectionSlider('#preco', '.cards-grid', '.feature-card');
        initSectionSlider('#ludia', '.ludia-carousel', '.ludia-card');
    })();

    // Mobile horizontal parallax in the "Prečo Boží dar" carousel: each card
    // image drifts a little relative to the card as the row is swiped. The CSS
    // (bozidar.css, max-width: 768px) widens the image and reads --parallax-x.
    document.querySelectorAll('.preco-section').forEach((section) => {
        const grid = section.querySelector('.cards-grid');
        const imgs = Array.from(section.querySelectorAll('.feature-card-img img'));
        if (!grid || !imgs.length) {
            return;
        }

        const FACTOR = 0.12;

        const tick = () => {
            const { left, width } = grid.getBoundingClientRect();
            const gridCenter = left + width / 2;
            imgs.forEach((img) => {
                const r = img.parentElement.getBoundingClientRect();
                const offset = (r.left + r.width / 2 - gridCenter) * FACTOR;
                img.style.setProperty('--parallax-x', `${offset.toFixed(2)}px`);
            });
        };

        let raf = null;
        grid.addEventListener('scroll', () => {
            if (raf) {
                return;
            }
            raf = requestAnimationFrame(() => {
                tick();
                raf = null;
            });
        }, { passive: true });
        window.addEventListener('resize', tick);
        tick();
    });

    // "Prečo Boží dar" cards: from 768px down the carousel has no hover state and the
    // text is clipped, so a tap opens a dialog with the full text instead.
    const featureCardQuery = window.matchMedia('(max-width: 768px)');
    let featureDialog = null;

    const openFeatureCard = (card) => {
        const title = card.querySelector('.feature-card-title-hover span, .feature-card-title');
        const text = card.querySelector('.feature-card-desc-hover');
        if (!title || !text) {
            return;
        }

        if (!featureDialog) {
            featureDialog = document.createElement('dialog');
            featureDialog.className = 'product-dialog';
            featureDialog.setAttribute('aria-labelledby', 'featureCardDialogTitle');
            featureDialog.innerHTML = `
                <form method="dialog" class="product-dialog-close-wrap">
                    <button type="submit" class="product-dialog-close" aria-label="Zavrieť">×</button>
                </form>
                <div class="product-dialog-content">
                    <h3 id="featureCardDialogTitle" class="product-dialog-title"></h3>
                    <p class="product-dialog-description"></p>
                </div>
            `;
            featureDialog.addEventListener('click', (event) => {
                if (event.target === featureDialog) {
                    featureDialog.close();
                }
            });
            featureDialog.addEventListener('close', () => document.body.classList.remove('dialog-open'));
            document.body.appendChild(featureDialog);
        }

        featureDialog.querySelector('.product-dialog-title').textContent = title.textContent.trim();
        featureDialog.querySelector('.product-dialog-description').textContent = text.textContent.trim();
        document.body.classList.add('dialog-open');
        featureDialog.showModal();
    };

    document.querySelectorAll('.feature-card').forEach((card) => {
        const wrapper = card.querySelector('.feature-card-wrapper');
        if (!wrapper) {
            return;
        }
        const syncAccessibility = () => {
            if (featureCardQuery.matches) {
                wrapper.setAttribute('role', 'button');
                wrapper.setAttribute('tabindex', '0');
            } else {
                wrapper.removeAttribute('role');
                wrapper.removeAttribute('tabindex');
            }
        };
        syncAccessibility();
        featureCardQuery.addEventListener('change', syncAccessibility);
        wrapper.addEventListener('click', () => {
            if (featureCardQuery.matches) {
                openFeatureCard(card);
            }
        });
        wrapper.addEventListener('keydown', (event) => {
            if (featureCardQuery.matches && (event.key === 'Enter' || event.key === ' ')) {
                event.preventDefault();
                openFeatureCard(card);
            }
        });
    });

    // Same mobile parallax for the people carousel (capped travel, as in the original).
    document.querySelectorAll('.ludia-section').forEach((section) => {
        const carousel = section.querySelector('.ludia-carousel');
        const imgs = Array.from(section.querySelectorAll('.ludia-card-img img'));
        if (!carousel || !imgs.length) {
            return;
        }

        const FACTOR = 0.12;
        const MAX_OFFSET = 40;

        const tick = () => {
            const { left, width } = carousel.getBoundingClientRect();
            const center = left + width / 2;
            imgs.forEach((img) => {
                const r = img.parentElement.getBoundingClientRect();
                const raw = (r.left + r.width / 2 - center) * FACTOR;
                const offset = Math.max(-MAX_OFFSET, Math.min(MAX_OFFSET, raw));
                img.style.setProperty('--parallax-x', `${offset.toFixed(2)}px`);
            });
        };

        let raf = null;
        carousel.addEventListener('scroll', () => {
            if (raf) {
                return;
            }
            raf = requestAnimationFrame(() => {
                tick();
                raf = null;
            });
        }, { passive: true });
        window.addEventListener('resize', tick);
        tick();
    });

    // Cart with wine: checkout stays disabled until the 18+ checkbox is ticked.
    // Delegated, because cart.js re-renders the cart footer after every change
    // (which also resets the checkbox and the button's disabled state).
    document.addEventListener('change', (event) => {
        const box = event.target.closest ? event.target.closest('[data-cart-age-confirm]') : null;
        if (!box) {
            return;
        }
        const scope = box.closest('cart-drawer, .cart__footer, form') || document;
        const button = scope.querySelector('[data-requires-age-confirm]') || document.querySelector('[data-requires-age-confirm]');
        if (button) {
            button.disabled = !box.checked;
        }
    });
    document.addEventListener('submit', (event) => {
        const box = document.querySelector('[data-cart-age-confirm]');
        if (box && !box.checked && (event.target.id === 'cart' || event.target.id === 'CartDrawer-Form')) {
            event.preventDefault();
        }
    });

    initStoresFromCsv();

    async function initStoresFromCsv() {
        const searchInput = document.querySelector('.store-search');
        const cardsContainer = document.querySelector('.store-cards');

        if (!searchInput || !cardsContainer) {
            return;
        }

        const strings = JSON.parse(document.querySelector('[data-store-strings]').textContent);
        const status = document.querySelector('.store-results-status');

        try {
            const response = await fetch((window.BOZIDAR && window.BOZIDAR.predajneCsvUrl) || '/js/predajne.csv');
            if (!response.ok) {
                throw new Error(`CSV load failed: ${response.status}`);
            }

            const csvText = await response.text();
            const rows = parseCsv(csvText);
            const stores = rows.map(mapCsvRowToStore).filter(store => store.name);

            renderStoreCards(stores, cardsContainer, strings, status);

            searchInput.addEventListener('input', () => {
                const query = normalizeText(searchInput.value.trim());

                const filtered = stores.filter((store) => {
                    const haystack = normalizeText([
                        store.name,
                        store.address,
                        store.hours,
                        store.mapUrl,
                        store.phone,
                        store.appleMapsUrl
                    ].join(' '));

                    return haystack.includes(query);
                });

                renderStoreCards(filtered, cardsContainer, strings, status);
            });
        } catch (error) {
            const message = document.createElement('p');
            message.textContent = strings.error;
            cardsContainer.replaceChildren(message);
            if (status) status.textContent = strings.error;
            console.error(error);
        } finally {
            cardsContainer.setAttribute('aria-busy', 'false');
        }
    }

    function openStoreHoursDialog(hoursText, strings) {
        let dialog = document.getElementById('storeHoursDialog');

        if (!dialog) {
            dialog = document.createElement('dialog');
            dialog.id = 'storeHoursDialog';
            dialog.className = 'product-dialog';
            dialog.setAttribute('aria-labelledby', 'storeHoursDialogTitle');
            dialog.innerHTML = `
                <form method="dialog" class="product-dialog-close-wrap">
                    <button type="submit" class="product-dialog-close" data-store-hours-dialog-close >×</button>
                </form>
                <div class="product-dialog-content">
                    <h3 id="storeHoursDialogTitle" class="product-dialog-title"></h3>
                    <p id="storeHoursDialogDescription" class="product-dialog-description"></p>
                </div>
            `;

            dialog.addEventListener('click', (event) => {
                if (event.target === dialog) {
                    dialog.close();
                }
            });

            dialog.addEventListener('close', () => {
                document.body.classList.remove('dialog-open');
            });

            dialog.querySelectorAll('[data-store-hours-dialog-close]').forEach((button) => {
                button.addEventListener('click', () => dialog.close());
            });

            document.body.appendChild(dialog);
        }

        dialog.querySelector('#storeHoursDialogTitle').textContent = strings.hours;
        dialog.querySelector('[data-store-hours-dialog-close]').setAttribute('aria-label', strings.close);
        const description = dialog.querySelector('#storeHoursDialogDescription');
        if (description) {
            description.textContent = hoursText || strings.hours_unavailable;
            description.style.whiteSpace = 'pre-line';
        }

        document.body.classList.add('dialog-open');
        if (typeof dialog.showModal === 'function') {
            dialog.showModal();
        } else {
            dialog.setAttribute('open', 'open');
        }
    }

    function renderStoreCards(stores, container, strings, status) {
        container.replaceChildren();
        if (status) status.textContent = `${strings.results} ${stores.length}`;

        if (!stores.length) {
            const message = document.createElement('p');
            message.textContent = strings.empty;
            container.appendChild(message);
            return;
        }

        const fragment = document.createDocumentFragment();

        stores.forEach((store) => {
            const card = document.createElement('div');
            card.className = 'store-card reveal d1 in';

            const textWrap = document.createElement('div');
            textWrap.className = 'store-card-text';

            const title = document.createElement('h3');
            title.textContent = store.name;

            const address = document.createElement('p');
            address.textContent = store.address ? `${strings.address}: ${store.address}` : store.description;

            textWrap.appendChild(title);
            textWrap.appendChild(address);
            card.appendChild(textWrap);

            const resolvedMapUrl = isAppleDevice() ? (store.appleMapsUrl || store.mapUrl) : store.mapUrl;

            const phoneNumber = String(store.phone || '').replace(/[\s().-]/g, '');
            const hasPhone = /^\+?\d{6,15}$/.test(phoneNumber);
            if (resolvedMapUrl || hasPhone || store.hours) {
                const actions = document.createElement('div');
                actions.className = 'store-card-actions';

                if (store.hours) {
                    const hours = document.createElement('button');
                    hours.type = 'button';
                    hours.className = 'store-card-link';
                    hours.textContent = strings.hours;
                    hours.setAttribute('aria-label', `${strings.hours}: ${store.name}`);
                    hours.setAttribute('aria-haspopup', 'dialog');
                    hours.addEventListener('click', () => openStoreHoursDialog(store.hours, strings));
                    actions.appendChild(hours);
                }

                if (resolvedMapUrl) {
                    const link = document.createElement('a');
                    link.href = resolvedMapUrl;
                    link.target = '_blank';
                    link.rel = 'noopener noreferrer';
                    link.className = 'store-card-button';
                    link.setAttribute('aria-label', `${strings.map}: ${store.name}`);
                    const icon = document.createElement('img');
                    icon.src = (window.BOZIDAR && window.BOZIDAR.mapPinIcon) || '/images/tabler-icon-map-pin.svg';
                    icon.alt = '';
                    link.appendChild(icon);
                    actions.appendChild(link);
                }

                if (hasPhone) {
                    const phone = document.createElement('a');
                    phone.href = `tel:${phoneNumber}`;
                    phone.className = 'store-card-button';
                    phone.setAttribute('aria-label', `${strings.phone}: ${store.name}`);
                    const icon = document.createElement('img');
                    icon.src = (window.BOZIDAR && window.BOZIDAR.phoneIcon) || '/images/tabler-icon-phone.svg';
                    icon.alt = '';
                    phone.appendChild(icon);
                    actions.appendChild(phone);
                }

                card.appendChild(actions);
            }

            fragment.appendChild(card);
        });

        container.appendChild(fragment);
    }

    function mapCsvRowToStore(row) {
        const name = firstDefined(
            row['nazov'],
            row['názov'],
            row['predajna'],
            row['predajňa'],
            row['nazov predajne'],
            row['názov predajne']
        );

        const street = firstDefined(row['ulica']);
        const city = firstDefined(row['mesto']);

        const address = joinAddress(city, street) || firstDefined(
            row['adresa'],
            row['adresa predajne'],
            row['mesto'],
            row['lokalita']
        );

        const hours = firstDefined(
            row['otvaracie hod'],
            row['otváracie hod'],
            row['otvaracie hodiny'],
            row['otváracie hodiny'],
            row['kratky popis'],
            row['krátky popis'],
            row['dlhy popis'],
            row['dlhý popis']
        );
        const phone = firstDefined(row['telefon'], row['telefón'], row['phone']);

        const mapUrl = firstDefined(
            row['link na google maps'],
            row['mapa'],
            row['map_url'],
            row['google maps'],
            row['google_maps'],
            row['url'],
            row['link']
        ) || buildGoogleMapsUrl(address);

        const appleMapsUrl = firstDefined(
            row['link na apple maps'],
            row['apple maps'],
            row['apple_maps']
        );

        return {
            name,
            address,
            hours,
            phone,
            mapUrl,
            appleMapsUrl
        };
    }

    function joinAddress(city, street) {
        if (city && street) {
            return `${city}, ${street}`;
        }

        return city || street || '';
    }

    function isAppleDevice() {
        return /iPad|iPhone|iPod|Macintosh/i.test(navigator.userAgent) && 'ontouchend' in document
            || /iPad|iPhone|iPod/.test(navigator.userAgent);
    }

    function buildGoogleMapsUrl(address) {
        if (!address) {
            return '';
        }

        return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
    }

    function firstDefined(...values) {
        for (const value of values) {
            if (typeof value === 'string' && value.trim()) {
                return value.trim();
            }
        }

        return '';
    }

    function normalizeText(text) {
        return (text || '')
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
    }

    function parseCsv(text) {
        const rows = [];
        let currentField = '';
        let currentRow = [];
        let inQuotes = false;

        for (let index = 0; index < text.length; index += 1) {
            const char = text[index];
            const nextChar = text[index + 1];

            if (char === '"') {
                if (inQuotes && nextChar === '"') {
                    currentField += '"';
                    index += 1;
                } else {
                    inQuotes = !inQuotes;
                }
                continue;
            }

            if (char === ',' && !inQuotes) {
                currentRow.push(currentField);
                currentField = '';
                continue;
            }

            if ((char === '\n' || char === '\r') && !inQuotes) {
                if (char === '\r' && nextChar === '\n') {
                    index += 1;
                }

                currentRow.push(currentField);
                const hasContent = currentRow.some(field => field.trim() !== '');

                if (hasContent) {
                    rows.push(currentRow);
                }

                currentField = '';
                currentRow = [];
                continue;
            }

            currentField += char;
        }

        if (currentField.length > 0 || currentRow.length > 0) {
            currentRow.push(currentField);
            const hasContent = currentRow.some(field => field.trim() !== '');
            if (hasContent) {
                rows.push(currentRow);
            }
        }

        if (!rows.length) {
            return [];
        }

        const headers = rows[0].map(header => header.trim().toLowerCase());

        return rows.slice(1).map((row) => {
            const mapped = {};

            headers.forEach((header, i) => {
                mapped[header] = (row[i] || '').trim();
            });

            return mapped;
        });
    }


});

// ─── Shopify theme-editor support ───────────────────────────────────────────
// In the editor, sections load/reload without a full page load, so the
// IntersectionObserver-driven reveals never fire. Force affected content
// visible so merchants can see what they are editing.
if (window.Shopify && window.Shopify.designMode) {
    var bozidarRevealIn = function (scope) {
        (scope || document)
            .querySelectorAll('.reveal, .reveal-left, .reveal-right, .reveal-up')
            .forEach(function (el) { el.classList.add('in'); });
        var heroBg = (scope || document).querySelector('#heroBg');
        if (heroBg) { heroBg.classList.add('loaded'); }
        (scope || document)
            .querySelectorAll('.landscape-line-svg path')
            .forEach(function (p) { p.style.strokeDashoffset = '0'; });
    };
    document.addEventListener('shopify:section:load', function (e) { bozidarRevealIn(e.target); });
    document.addEventListener('shopify:section:select', function (e) { bozidarRevealIn(e.target); });
    document.addEventListener('DOMContentLoaded', function () { bozidarRevealIn(document); });
}
